import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, createSeriesEntry } from 'store/data/entries';

type HandlerInput = Parameters<typeof createSeriesEntry>;

export function useCreateSeriesEntry(): Operation<(...input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.CREATE_SERIES_ENTRY);

	async function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(createSeriesEntry(...input));
	}

	return [{ loading, error }, handler];
}
